<template>
  <form @submit.prevent="onSubmit">
    <b-container>
      <b-row class="align-items-end">
        <b-col class="my-2" lg="3">
          <form-group class="col-lg-12 col-md-12  text-right" :validations="$v.filterTimings.timable_type">
            <div slot-scope="{ errors, invalid }">
              <label>نوع زمان بندی</label>
              <b-form-select @change="filterTimingsTypeChange()" class="col-lg-12" v-model="filterTimings.timable_type"
                             :options="timingTypeOptions"></b-form-select>
              <form-errors-manager :errors="errors"/>
            </div>
          </form-group>
        </b-col>
        <b-col class="my-2" lg="3">

          <form-group class="col-lg-12 col-md-12  text-right" :validations="$v.filterTimings.open_at">
            <div slot-scope="{ errors, invalid }">
              <label>شروع بازه</label>

              <date-picker v-model="filterTimings.open_at" clearable auto-submit format="YYYY-MM-DD HH:mm:ss"
                           display-format="HH:mm:ss jYYYY/jM/jD "
                           type="datetime"/>

              <form-errors-manager :errors="errors"/>
            </div>
          </form-group>


        </b-col>
        <b-col class="my-2" lg="3">
          <form-group class="col-lg-12 col-md-12  text-right" :validations="$v.filterTimings.close_at">
            <div slot-scope="{ errors, invalid }">
              <label>پایان بازه</label>

              <date-picker v-model="filterTimings.close_at" clearable auto-submit format="YYYY-MM-DD HH:mm:ss"
                           display-format="HH:mm:ss jYYYY/jM/jD"
                           :min="filterTimings.open_at"
                           type="datetime"/>

              <form-errors-manager :errors="errors"/>
            </div>
          </form-group>
        </b-col>
        <b-col class="my-2" lg="3">
          <b-col lg="12" class="text-center">
            <b-button class="mx-auto w-75" variant="secondary" pill type="submit">فیلتر</b-button>
          </b-col>
        </b-col>
      </b-row>
    </b-container>
  </form>
</template>

<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import FormGroup from "../../validator/FormGroup";
import FormErrorsManager from "../../validator/FormErrorsManager";
import {TimingFilters} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Timing";
import {required} from "vuelidate/lib/validators";

export default {
  name: "TimingFilters",
  components: {datePicker: VuePersianDatetimePicker, FormGroup, FormErrorsManager,},
  data() {
    return {
      TimingFilters,
      filterTimings: {
        timable_type: 'all',
        open_at: '',
        close_at: '',
      }
    }
  },
  computed: {
    timingTypeOptions() {
      let timingTypes = []
      timingTypes.push({value: 'all', text: 'همه'})
      Object.keys(this.TimingFilters).forEach(item => {
        let base = this.TimingFilters[item];
        timingTypes.push({value: base.value, text: base.label})
      })
      return timingTypes
    },
  },
  validations: {
    filterTimings: {
      timable_type: {required},
      open_at: {},
      close_at: {},
    }
  },
  methods: {
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit() {
      if (this.invalid()) {

        const form = {
          timable_type: this.filterTimings.timable_type
        };

        if (this.filterTimings.open_at !== '') {
          form.open_at = this.filterTimings.open_at
        }
        if (this.filterTimings.close_at !== '') {
          form.close_at = this.filterTimings.close_at
        }
        this.$emit('filters', form)
      }
    },
    filterTimingsTypeChange() {
      this.$emit('typeChanged', true)
    }
  }
}
</script>

<style scoped>

</style>